import { List } from 'antd';
import React, { FC } from 'react';
import Card from './Card';
import styles from './InProgressTab.module.less';
import { inProgress } from '../datas';

const InProgressTab: FC = () => {
  return (
    <List
      className={styles.root}
      itemLayout="vertical"
      size="large"
      pagination={{
        onChange: () => {
          const el: any = document.querySelector('#tabs');
          el.scrollIntoView({ behavior: 'smooth' });
        },
        hideOnSinglePage: true,
        pageSize: 5,
      }}
      dataSource={inProgress}
      renderItem={(item) => <Card {...item} />}
    />
  );
};

export default InProgressTab;
